import React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import EventAdvertisement from '@cards/EventAdvertisement';

const CartEventAdsHits = ({ hits }) => {
    return (
        <div>
            {hits.map(hit => (
                <div key={hit.objectID} className="mt-1rem">
                    <EventAdvertisement eventCode={hit.event_code} boosted={hit.boosted} />
                </div>
            ))}
        </div>
    );
};

CartEventAdsHits.propTypes = {
    hits: PropTypes.array.isRequired,
};

export default connectHits(CartEventAdsHits);
